import React from 'react';
import {APIProvider} from '@vis.gl/react-google-maps';

const MapProvider = ({children}) => {
    return (
        <>
            <APIProvider apiKey="AIzaSyAsh-ofw4XiKuvo4W1GOIutG7NpHLbp2Hw">
                {children}
            </APIProvider>
        </>
    );
};

export default MapProvider;